import { render, staticRenderFns } from "./TermsText.vue?vue&type=template&id=0578bdac&"
import script from "./TermsText.vue?vue&type=script&lang=js&"
export * from "./TermsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports